import { jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import DateTime from "../../../../../vendor/luxon/src/datetime.js";
import "../../../../../vendor/luxon/src/duration.js";
import { useCallback, useMemo } from "react";
import { MonthsSelector } from "./MonthsSelector.js";
import { YearSelector } from "./YearSelector.js";
const MonthYearSelector = ({
  disabledTo,
  disabledFrom,
  show,
  from,
  to,
  type,
  selected,
  onChange
}) => {
  const currentSelectedDate = DateTime.fromISO(selected), selectedYear = currentSelectedDate == null ? void 0 : currentSelectedDate.year, selectedMonth = currentSelectedDate == null ? void 0 : currentSelectedDate.month, fromDefault = DateTime.now().year, toDefault = fromDefault - 100, handleMonthChange = useCallback(
    (month) => {
      const isoDate = (currentSelectedDate != null && currentSelectedDate.isValid ? currentSelectedDate.set({ month }) : DateTime.now().set({ month })).toISODate();
      onChange(isoDate);
    },
    [currentSelectedDate, onChange]
  ), handleYearChange = useCallback(
    (year) => {
      const isoDate = (currentSelectedDate != null && currentSelectedDate.isValid ? currentSelectedDate.set({ year }) : DateTime.now().set({ year })).toISODate();
      onChange(isoDate);
    },
    [currentSelectedDate, onChange]
  ), { disableMonthTo, disableMonthFrom, disableYearTo, disableYearFrom } = useMemo(() => {
    let disableMonthFrom2, disableMonthTo2, disableYearFrom2, disableYearTo2;
    if (!disabledFrom && !disabledTo)
      return {
        disableYearFrom: disableYearFrom2,
        disableMonthFrom: disableMonthFrom2,
        disableMonthTo: disableMonthTo2,
        disableYearTo: disableYearTo2
      };
    if (disabledFrom) {
      const disableFromDate = DateTime.fromISO(disabledFrom);
      disableYearFrom2 = disableFromDate.year + 1, currentSelectedDate.year === disableFromDate.year ? disableMonthFrom2 = disableFromDate.month + 1 : currentSelectedDate.year > disableFromDate.year && (disableMonthFrom2 = 1);
    }
    if (disabledTo) {
      const disableToDate = DateTime.fromISO(disabledTo);
      disableYearTo2 = disableToDate.year - 1, currentSelectedDate.year === disableToDate.year ? disableMonthTo2 = disableToDate.month - 1 : currentSelectedDate.year < disableToDate.year && (disableMonthFrom2 = 1);
    }
    return {
      disableYearFrom: disableYearFrom2,
      disableMonthFrom: disableMonthFrom2,
      disableMonthTo: disableMonthTo2,
      disableYearTo: disableYearTo2
    };
  }, [currentSelectedDate.year, disabledFrom, disabledTo]);
  return show ? /* @__PURE__ */ jsx(Stack, { sx: styles.monthYearSelectors, children: type === "month" ? /* @__PURE__ */ jsx(
    MonthsSelector,
    {
      selected: selectedMonth,
      onChange: handleMonthChange,
      disableMonthTo,
      disableMonthFrom
    }
  ) : /* @__PURE__ */ jsx(
    YearSelector,
    {
      from: from ?? fromDefault,
      to: to ?? toDefault,
      selected: selectedYear,
      onChange: handleYearChange,
      disableYearTo,
      disableYearFrom
    }
  ) }) : null;
}, styles = {
  monthYearSelectors: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: (t) => t.palette.picker.primary.segment.normal.bg.default
  }
};
export {
  MonthYearSelector
};
//# sourceMappingURL=MonthYearSelector.js.map
